import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $a02d57049d202695$export$d085fb9e920b5ca7 = /*#__PURE__*/function (_Symbol$iterator) {
  function $a02d57049d202695$export$d085fb9e920b5ca7(nodes) {
    var _this = this;

    _classCallCheck(this, $a02d57049d202695$export$d085fb9e920b5ca7);

    this.keyMap = new Map();
    this.firstKey = null;
    this.lastKey = null;
    this.iterable = nodes;

    var _visit = function visit(node) {
      _this.keyMap.set(node.key, node);

      if (node.childNodes && node.type === 'section') {
        var _iterator = _createForOfIteratorHelper(node.childNodes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;

            _visit(child);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };

    var _iterator2 = _createForOfIteratorHelper(nodes),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var node = _step2.value;

        _visit(node);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var last = null;
    var index = 0;

    var _iterator3 = _createForOfIteratorHelper(this.keyMap),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value2 = _slicedToArray(_step3.value, 2),
            key = _step3$value2[0],
            _node = _step3$value2[1];

        if (last) {
          last.nextKey = key;
          _node.prevKey = last.key;
        } else {
          this.firstKey = key;
          _node.prevKey = undefined;
        }

        if (_node.type === 'item') _node.index = index++;
        last = _node; // Set nextKey as undefined since this might be the last node
        // If it isn't the last node, last.nextKey will properly set at start of new loop

        last.nextKey = undefined;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    var _last_key;

    this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
  }

  return _createClass($a02d57049d202695$export$d085fb9e920b5ca7, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(this.iterable, "t0", 1);

          case 1:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return this.keyMap.size;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);

      var _node_prevKey;

      return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);

      var _node_nextKey;

      return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      return this.firstKey;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      return this.lastKey;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this_keyMap_get;

      return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());

      return this.getItem(keys[idx]);
    }
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      var node = this.keyMap.get(key);
      return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
  }]);
}(Symbol.iterator);

export { $a02d57049d202695$export$d085fb9e920b5ca7 as ListCollection };